import { month } from "../../period/PeriodType.js";
import AbstractSeriesSpecification from "./AbstractSeriesSpecification.js";
import KeyFigureFormulaNode from "../../keyFigure/formula/KeyFigureFormulaNode.js";
import PeriodRollingFormulaNode from "../../keyFigure/formula/PeriodRollingFormulaNode.js";

/**
 * Concrete implementation of an {@link AbstractSeriesSpecification}
 * representing a computation request for a {@link RollingPeriodFormulaNode}.
 */
export default class PeriodRollingSeriesSpecification extends AbstractSeriesSpecification {
	static makeNodeFromModel({ keyFigure, rollingLength }) {
		return new PeriodRollingFormulaNode({
			expression: new KeyFigureFormulaNode({ keyFigure }),
			rollingLength,
			periodType: month,
		});
	}

	static getType() {
		return "PeriodRollingSeriesSpecification";
	}
}
